export { SORT_TYPES } from './sortTypes';

export const GIVING_BY_CAMPAIGN_COLUMNS = [
  { id: 'name', label: 'Campaign', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'campaign_type', label: 'Type', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', defaultVisible: true, sortable: true, sortType: 'lifecycle' },
  { id: 'goal_amount', label: 'Goal', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'total_raised', label: 'Total Raised', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'donor_count', label: 'Donors', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'gift_count', label: 'Gifts', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'progress', label: 'Progress', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'pledged_amount', label: 'Pledged', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'pledge_received_amount', label: 'Pledge Payments Received', defaultVisible: false, sortable: true, sortType: 'currency' },
  { id: 'outstanding_amount', label: 'Outstanding Pledged', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'raised_plus_outstanding', label: 'Raised + Outstanding', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'start_date', label: 'Start', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'end_date', label: 'End', defaultVisible: true, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  GIVING_BY_CAMPAIGN_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  GIVING_BY_CAMPAIGN_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
